import React, { useState, useMemo } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import EditionsTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import useRPDBarCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useRPDBarCharts';
import { getPlatformName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import { useIntl } from 'umi';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';

const EditionsShareCard = (props: any) => {
  const {
    dateType,
    lineData,
    tableData = [],
    unPublishedAppIdList = [],
    changeSegement,
    chartType,
    setChartType,
    cardStatus,
    topChartsType = 'stats-rpdedition-bar',
    asForDate,
    fixedTableData,
    metricSegVal,
    pageSortAttr,
    onTableSortChage,
    entityType,
    dataSource,
    lineXAxisData,
  } = props;
  const { rpdSegementOptions, rpdSegementTitleObj } = useMobileOptionList();
  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [chartType, setChartType] = useState('bar');

  const barOrPieData = useMemo(() => {
    if (!Array.isArray(tableData) || tableData?.length < 1) return [];
    const listTemp = tableData.filter((item) => item.app_id != '');

    return listTemp?.map((item: any) => {
      return { ...item, name: `${item.name}(${getPlatformName(item.platform)})` };
    });
  }, [tableData]);

  // 柱状图相关hooks
  const { seriesData: barSeriesData, barNameList } = useRPDBarCharts(
    metricSegVal,
    barOrPieData,
    topChartsType,
    'stats',
  );

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_editions_share` })}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <div className="dbi-editionsshare-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_detail_editions_share` })}
        disableChartType={['pie']}
        activeTab={chartType}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <Segment
          value={metricSegVal}
          onChange={(value) => {
            // setMetricSegVal(value);
            changeSegement?.(value);
          }}
          options={rpdSegementOptions}
        />
        <div className="editionsshare-card-line">
          <Visualis
            chartType={chartType}
            lineData={lineData}
            barData={tableData}
            barSeriesData={barSeriesData}
            barNameList={barNameList}
            topChartsType={topChartsType}
            chartSegment={metricSegVal}
            barOrPieData={barOrPieData}
            titleNow={rpdSegementTitleObj[metricSegVal]}
            dateType={dateType}
            lineXAxisData={lineXAxisData}
          />
        </div>
        {/* 表格头部加table-header-normal没有排序样式  table-header是排序样式*/}

        <EditionsTable
          chartSegment={metricSegVal} /** 用于表格展示排序 */
          tableData={tableData}
          unPublishedAppIdList={unPublishedAppIdList}
          asForDate={asForDate}
          fixedTableData={fixedTableData}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
          entityType={entityType}
          dataSource={dataSource}
        />
      </CardSlotV2>
    </div>
  );
};

export default EditionsShareCard;
